/* ============================================================
   DE REKENHULP — van één meting naar één maat.

   TWEE REGELS, ALLEBEI VASTGESTELD DOOR ARMYAN OP 28-08-2026.

   1. HALSTER: DE TABELWAARDE IS DE BOVENGRENS.
      In de ontwikkelmatrix staat één bakstukmaat per maat: 8 / 9,5 / 11,5 / 14 /
      17 / 21 cm. Dat zijn geen middelpunten maar plafonds. Meet je 11,5 dan past
      D3 precies; meet je 11,6 dan is D3 te klein en wordt het D4. Twijfel gaat
      dus altijd naar de ruimere maat, en dat is de goede kant op: een halster
      met gaatjes kun je kleiner zetten, groter niet.

   2. DEKEN: B BESLIST.
      De klant meet A (schoft tot staart) en B (borst tot bil). B bepaalt de
      maat, want te kort rond de romp is niet op te lossen en een iets langere
      ruglijn wel. Wijst A een andere maat aan, dan zeggen we dat erbij. Een
      afwijking verzwijgen levert een retour op.

   ALLES BLIJFT IN DE BROWSER. Er gaat geen meting naar een server, dus er valt
   ook niets te bewaren of te lekken.

   DE KLEM IS ÉÉN ELEMENT DAT SCHAALT, geen plaatje dat wordt vervangen. Dat
   verschil is de hele beweging: herschrijven springt, schalen gaat open.
   ============================================================ */
(function () {
  /* De productpagina laadt dit bestand zelf én via de rekenhulpsectie als die
     er ook staat. Twee keer koppelen geeft dubbele uitkomsten; één keer is genoeg. */
  if (window.__donqRekenhulp) return;
  window.__donqRekenhulp = true;

  const secties = document.querySelectorAll('[data-rekenhulp]');
  if (!secties.length) return;

  /* Dezelfde zes breedtes als snippets/klem.liquid. De reeks is NIET gelijkmatig,
     want de echte maten zijn dat ook niet. Verzin hier nooit een nette reeks voor,
     dan liegt het teken. */
  const KLEM = { D1: 16.0, D2: 19.5, D3: 23.8, D4: 26.4, D5: 35.9, D6: 42.0 };
  const KLEM_MAX = 42;

  /* De velden zijn type=text en geen type=number, want een number-veld WEIGERT
     een komma en dat is precies wat je op een Nederlands toetsenbord intikt:
     "12,8" kwam er nooit in. inputmode=decimal geeft op een telefoon hetzelfde
     cijferbord. Daardoor moeten we hier zelf opschonen. */
  /* Streng, en met opzet. De vorige versie streepte alles weg wat geen cijfer of
     punt was, en dat maakte van "-5" gewoon 5: een min die verdwijnt zonder dat
     iemand het merkt en een maat die eruit rolt alsof er niets aan de hand is.
     Ook "12,,8" werd stilletjes 12,8. Een maat is te belangrijk om te raden wat
     er bedoeld werd, dus onleesbare invoer levert nu niets op in plaats van iets
     aannemelijks. Komma en punt mogen allebei, want de een typt het zo en de
     ander zo, maar er mag er maar een staan. */
  const getal = v => {
    const tekst = String(v == null ? '' : v).trim().replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(tekst)) return null;
    const n = parseFloat(tekst);
    return Number.isFinite(n) && n > 0 && n < 500 ? n : null;
  };
  const toon = n => String(n).replace('.', ',');

  function klemHtml(maat) {
    const w = (KLEM[maat] || 26.4) / KLEM_MAX;
    return `<span class="klem rekenhulp__klem" data-maat="${maat}" data-toestand="gezet"
                  role="img" aria-label="Maat ${maat}">
      <svg viewBox="0 0 64 34" aria-hidden="true">
        <g class="klem__g" style="transform:scaleX(${w.toFixed(4)})">
          <line x1="11" y1="30" x2="53" y2="30" vector-effect="non-scaling-stroke"/>
          <line x1="11" y1="30" x2="11" y2="16" vector-effect="non-scaling-stroke"/>
          <line x1="53" y1="30" x2="53" y2="12" vector-effect="non-scaling-stroke"/>
        </g>
      </svg></span>`;
  }

  /* De klem opnieuw schrijven laat hem springen. Staat hij er al, dan verzetten
     we alleen zijn schaal en zijn label. */
  function zetKlem(uit, maat) {
    const bestaand = uit.querySelector('.rekenhulp__klem');
    if (!bestaand) return false;
    bestaand.dataset.maat = maat;
    bestaand.setAttribute('aria-label', 'Maat ' + maat);
    const g = bestaand.querySelector('.klem__g');
    if (g) g.style.transform = `scaleX(${((KLEM[maat] || 26.4) / KLEM_MAX).toFixed(4)})`;
    return true;
  }

  /* In de compacte stand (het maatblok op de productpagina) staat de matrix
     al in de maattabel en de klemmen staan er pal boven; daar volstaat het
     dier en, als het ertoe doet, een waarschuwing. */
  const compact = uit => !!uit.closest('.rekenhulp--compact');
  function schrijf(uit, maat, regels, kort) {
    const had = zetKlem(uit, maat);
    const lijst = (kort && compact(uit)) ? kort : regels;
    const romp = `<strong class="rekenhulp__maat">Maat ${maat}</strong>` +
                 lijst.map(r => `<span class="rekenhulp__regel">${r}</span>`).join('');
    if (had) {
      [...uit.childNodes].forEach(n => { if (!n.classList || !n.classList.contains('rekenhulp__klem')) n.remove(); });
      uit.insertAdjacentHTML('beforeend', romp);
    } else {
      uit.innerHTML = klemHtml(maat) + romp;
    }
    uit.dataset.maat = maat;
  }

  function leeg(uit, bericht) {
    uit.innerHTML = bericht ? `<span class="rekenhulp__regel rekenhulp__regel--let">${bericht}</span>` : '';
    delete uit.dataset.maat;
  }

  /* DE KERN. Zoek de eerste maat waarvan de waarde groot genoeg is.
     Precies op de grens telt als passend; alles daarboven schuift een maat op. */
  function kiesOpBovengrens(rijen, veld, cm) {
    return rijen.find(r => cm <= r[veld]) || null;
  }

  /* HET BAKSTUK IS EEN LICHAAMSMAAT MET OVERLAPPENDE BEREIKEN.
     De matrix geeft per maat een doel en een bereik op het dier, en die bereiken
     lopen in elkaar over: 17 cm past bij D3 (15 tot 19) en bij D4 (17 tot 22).
     Dat is geen slordigheid; ezels zijn zo, en een halster verstelt. Dus:
     1. valt de meting in het bereik van de maat die de schofthoogte al aanwees,
        dan is dat de maat: twee metingen die het eens zijn winnen van een;
     2. anders het dichtstbijzijnde doel, en bij gelijke afstand de grotere,
        want een ruimer halster kun je aantrekken en een knellend niet. */
  let schoftMaat = null;
  function kiesBakstuk(rijen, cm, voorkeur) {
    const past = rijen.filter(r => cm >= r.bak_van && cm <= r.bak_tot);
    if (!past.length) return null;
    if (voorkeur) { const v = past.find(r => r.maat === voorkeur); if (v) return v; }
    return past.reduce((a, b) => {
      const va = Math.abs(a.bak_doel - cm), vb = Math.abs(b.bak_doel - cm);
      return (vb < va || (vb === va && b.bak_doel > a.bak_doel)) ? b : a;
    });
  }


  /* ---------- DE VERSTELBALK ----------
     Kroonstuk, neusomtrek en keelstuk kunnen geen maat BEPALEN, want hun
     bereiken overlappen: 48 cm neusomtrek past zowel bij D3 als bij D4. Ze
     kunnen een maat wel CONTROLEREN, en dat is waar hun waarde ligt.

     De balk toont het verstelbereik van die riem bij de gekozen maat, met een
     streep op de plek van jouw meting. Zo zie je niet alleen DAT het past maar
     ook hoeveel ruimte je overhoudt, en dat is precies wat iemand wil weten die
     twijfelt tussen twee maten. */
  function bereikUit(tekst){
    const d = String(tekst).split('tot').map(x => parseFloat(x.replace(',', '.').trim()));
    return (d.length === 2 && d.every(Number.isFinite)) ? d : null;
  }

  function balk(naam, waarde, bereik) {
    const [van, tot] = bereik;
    const binnen = waarde >= van && waarde <= tot;
    /* buiten het bereik zetten we de markering op de rand en zeggen we het;
       hem buiten de balk tekenen suggereert een schaal die er niet is */
    const p = Math.max(0, Math.min(100, ((waarde - van) / (tot - van)) * 100));
    const ruimteOnder = (waarde - van).toFixed(1).replace('.', ',');
    const ruimteBoven = (tot - waarde).toFixed(1).replace('.', ',');
    /* Op de rand van het bereik leest "0,0 cm strakker" als een rekenfout.
       Het is er geen: je staat dan gewoon op de uiterste stand, en dat is
       precies wat iemand moet weten die twijfelt tussen twee maten. */
    const oordeel = binnen
      ? (waarde - van < 0.05
          ? `staat op de strakste stand, ${ruimteBoven} cm ruimer te zetten`
          : (tot - waarde < 0.05
              ? `staat op de ruimste stand, ${ruimteOnder} cm strakker te zetten`
              : `${ruimteOnder} cm strakker en ${ruimteBoven} cm ruimer te zetten`))
      : (waarde < van
          ? `valt ${(van - waarde).toFixed(1).replace('.', ',')} cm ONDER het bereik van deze maat`
          : `valt ${(waarde - tot).toFixed(1).replace('.', ',')} cm BOVEN het bereik van deze maat`);
    return `<div class="balk${binnen ? '' : ' balk--buiten'}">
      <div class="balk__kop"><span>${naam}</span><b>${toon(waarde)} cm</b></div>
      <div class="balk__spoor">
        <span class="balk__vul" style="left:${p.toFixed(1)}%"></span>
      </div>
      <div class="balk__voet"><span>${toon(van)}</span><em>${oordeel}</em><span>${toon(tot)}</span></div>
    </div>`;
  }

  function start(sectie) {
    const dataEl = sectie.querySelector('[data-rekendata]');
    if (!dataEl) return;
    let D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

    /* Op de productpagina staan deze velden IN het koopformulier. Enter zou
       daar het formulier verzenden en het product in de wagen leggen; hier
       betekent Enter "klaar": veld verlaten, toetsenbord weg, meting staat. */
    sectie.querySelectorAll('input').forEach(v => v.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); v.blur(); }
    }));

    /* ---------- wisselen tussen halster en deken ---------- */
    const tabs = [...sectie.querySelectorAll('.rekenhulp__tab')];
    const blokken = [...sectie.querySelectorAll('.rekenhulp__blok')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => {
        const aan = t === tab;
        t.classList.toggle('is-aan', aan);
        t.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      blokken.forEach(b => b.classList.toggle('is-weg', b.dataset.voor !== tab.dataset.voor));
    }));

    /* ---------- DE SCHOFTHOOGTE: ÉÉN METING, TWEE PRODUCTEN ----------
       De schofthoogte staat in beide tabellen met dezelfde grenzen, dus hij
       geeft in één klap een maat voor het halster en voor de deken. Dat maakt
       hem de goedkoopste meting die er is: bijna iedereen weet de schofthoogte
       van zijn ezel al, en niemand hoeft ervoor met een meetlint langs het
       hoofd.

       Hij beslist alleen niet. Het halster staat of valt bij het bakstuk, de
       deken bij de totale lengte. Daarom zetten we de maat wel meteen klaar,
       maar zeggen we er in dezelfde adem bij wat je moet meten om zeker te
       weten dat het klopt. Een startpunt dat zich voordoet als een eindoordeel
       is erger dan geen startpunt.

       Let op de grens tussen D5 en D6: het blad laat D5 tot 145 lopen en D6 bij
       140 beginnen. Die overlap lossen we op zoals overal, met de bovengrens,
       dus 140 tot 145 komt op D5 uit. Bij een ezel in dat gebied vragen we om
       door te meten in plaats van te gokken. */
    const schoftForm = sectie.querySelector('[data-schoft]');
    if (schoftForm && D.halster && D.deken) {
      const vSchoft = schoftForm.querySelector('[data-meting="schoft"]');
      const uitSchoft = schoftForm.querySelector('.schoft__uit') || sectie.querySelector('[data-uitkomst]');

      const rekenSchoft = () => {
        const cm = getal(vSchoft.value);
        if (cm === null) { leeg(uitSchoft, ''); return; }
        if (cm < 40 || cm > 200) {
          leeg(uitSchoft, 'Een schofthoogte ligt tussen 40 en 200 cm. Meet van de grond tot het hoogste punt van de schouder.');
          return;
        }
        const rij = kiesOpBovengrens(D.halster, 'schoft', cm);
        if (!rij) { leeg(uitSchoft, 'Deze hoogte valt buiten de reeks. Neem contact op.'); return; }

        /* de zin past zich aan de stand aan: op een productpagina met alleen
           halsters is praten over dekens alleen maar ruis */
        const modus = schoftForm.dataset.modus || 'beide';
        const geldt = modus === 'halster' ? ''
                    : modus === 'deken'   ? ''
                    : ' Deze maat geldt voor het halster en voor de deken.';
        const regels = ['Dat is ' + rij.dier + '.' + geldt];
        /* de randgevallen eerlijk benoemen in plaats van ze glad te strijken */
        if (cm > 140 && cm <= 145) {
          regels.push(modus === 'deken'
            ? 'Je zit op de grens van D5 en D6. Meet de totale lengte om zeker te weten welke kant het op valt.'
            : modus === 'halster'
            ? 'Je zit op de grens van D5 en D6. Meet het bakstuk om zeker te weten welke kant het op valt.'
            : 'Je zit op de grens van D5 en D6. Hier moet je doormeten: het bakstuk voor het halster, de totale lengte voor de deken.');
        } else if (rij.schoft !== 999 && rij.schoft - cm <= 3) {
          regels.push('Je zit dicht tegen de volgende maat aan. Meet het bakstuk om zeker te weten welke kant het op valt.');
        } else {
          regels.push(modus === 'deken'
            ? 'Wil je het zeker weten, meet dan de totale lengte van borst tot bil.'
            : modus === 'halster'
            ? 'Wil je het zeker weten, meet dan het bakstuk.'
            : 'Wil je het zeker weten, meet dan het bakstuk voor het halster of de totale lengte voor de deken.');
        }

        schoftMaat = rij.maat;
        /* het bakstuk beslist: staat dat veld al gevuld, dan rekent dát opnieuw
           met de nieuwe schofthoogte als voorkeur, en schrijft het de uitkomst */
        if (sectie.__herrekenHalster && sectie.__herrekenHalster.heeftWaarde()) {
          sectie.__herrekenHalster();
          return;
        }
        const kortSchoft = [`Schofthoogte ${toon(cm)} cm wijst naar ${rij.maat}, ${rij.dier}.`];
        if (cm > 140 && cm <= 145) kortSchoft.push('Dat ligt op de grens van D5 en D6. Het bakstuk beslist.');
        else if (rij.schoft !== 999 && rij.schoft - cm <= 3) kortSchoft.push(`Dicht bij de volgende maat. Het bakstuk beslist.`);
        else kortSchoft.push('Meet het bakstuk om het zeker te weten.');
        schrijf(uitSchoft, rij.maat, regels, kortSchoft);
        onthoud(rij.maat, cm);
        markeerOveral(rij.maat);
        kiesMaat(rij.maat);
      };

      vSchoft.addEventListener('input', rekenSchoft);
      vSchoft.addEventListener('change', rekenSchoft);
    }

    /* ---------- halster ---------- */
    const halster = sectie.querySelector('.rekenhulp__blok[data-voor="halster"]');
    if (halster) {
      const veld = halster.querySelector('[data-meting="bakstuk"]');
      const uit = halster.querySelector('.rekenhulp__uit') || sectie.querySelector('[data-uitkomst]');
      const reken = () => {
        const cm = getal(veld.value);
        /* het ezelshoofd op de productpagina zet de meting bij de maatlijn */
        document.dispatchEvent(new CustomEvent('donq:meting', { detail: { veld: 'bakstuk', cm: cm && cm > 0 ? cm : null } }));
        if (cm === null || cm <= 0) return leeg(uit, '');
        const rij = kiesBakstuk(D.halster, cm, schoftMaat);
        if (!rij) {
          const kleinste = D.halster[0], grootste = D.halster[D.halster.length - 1];
          return leeg(uit, cm < kleinste.bak_van
            ? `Kleiner dan onze kleinste maat (${kleinste.maat}, vanaf ${toon(kleinste.bak_van)} cm). Meet nog een keer langs de wangriem, of stuur ons je meting.`
            : `Groter dan onze grootste maat (${grootste.maat}, tot ${toon(grootste.bak_tot)} cm). Stuur ons je meting, dan kijken we mee.`);
        }
        const regels = [
          `Bakstuk ${toon(rij.bak_van)} tot ${toon(rij.bak_tot)} cm · riem ${toon(rij.riem)} cm · ${rij.gaatjes} gaatjes`,
          `Neusomtrek ${rij.neus} cm · kroonstuk ${rij.kroon} cm`,
          rij.dier,
        ];
        /* Eerlijk over de overlap: valt de meting ook in een buurmaat, dan zeggen
           we dat, en we zeggen waarom deze won. */
        const ook = D.halster.filter(r => r !== rij && cm >= r.bak_van && cm <= r.bak_tot);
        if (ook.length) {
          const namen = ook.map(r => r.maat).join(' en ');
          regels.push(schoftMaat === rij.maat
            ? `${toon(cm)} cm past ook bij ${namen}. Je schofthoogte wijst naar ${rij.maat}, dus die houden we aan.`
            : `${toon(cm)} cm past ook bij ${namen}. Twijfel je, neem dan de grotere; meet anders ook de schofthoogte.`);
        }
        const kort = [`Bakstuk ${toon(cm)} cm valt binnen ${toon(rij.bak_van)} tot ${toon(rij.bak_tot)} cm: ${rij.dier}.`];
        if (ook.length) {
          const namen = ook.map(r => r.maat).join(' en ');
          if (schoftMaat === rij.maat) kort.push(`${toon(cm)} cm past ook bij ${namen}; je schofthoogte is het met ${rij.maat} eens.`);
          else if (schoftMaat) kort.push(`Je schofthoogte wijst naar ${schoftMaat}, je bakstuk naar ${rij.maat}. Het bakstuk beslist. Twijfel je, meet het dan nog een keer.`);
          else kort.push(`${toon(cm)} cm past ook bij ${namen}. Zonder schofthoogte kiezen we de grotere. Vul de schofthoogte in, die beslist.`);
        } else if (schoftMaat && schoftMaat !== rij.maat) {
          kort.push(`Je schofthoogte wijst naar ${schoftMaat}, je bakstuk naar ${rij.maat}. Het bakstuk beslist.`);
        }
        schrijf(uit, rij.maat, regels, kort);
        /* HIER WORDT HET EEN SYSTEEM: de meting kiest de maat. */
        onthoud(rij.maat, cm);
        markeerOveral(rij.maat);
        if (kiesMaat(rij.maat) && !compact(uit)) meldGekozen(uit, rij.maat);
      };
      /* de controlevelden hangen aan dezelfde uitkomst: verandert het bakstuk,
         dan verandert de maat en dus ook waartegen we controleren */
      const balkenVak = halster.querySelector('[data-balken]');
      const checks = [...halster.querySelectorAll('[data-check]')];
      const VELDNAAM = { neus: 'Neusomtrek', kroon: 'Kroonstuk', keel: 'Keelstuk' };
      function tekenBalken() {
        const cm = getal(veld.value);
        const rij = cm ? kiesBakstuk(D.halster, cm, schoftMaat) : null;
        if (!rij || !balkenVak) { if (balkenVak) balkenVak.innerHTML = ''; return; }
        const stukken = checks.map(c => {
          const w = getal(c.value);
          if (w === null) return '';
          const b = bereikUit(rij[c.dataset.check]);
          return b ? balk(VELDNAAM[c.dataset.check], w, b) : '';
        }).filter(Boolean);
        balkenVak.innerHTML = stukken.length
          ? `<p class="rekenhulp__balkkop">Zo valt jouw dier binnen ${rij.maat}</p>` + stukken.join('')
          : '';
      }
      const alles = () => { reken(); tekenBalken(); };
      alles.heeftWaarde = () => getal(veld.value) !== null;
      sectie.__herrekenHalster = alles;
      /* Eerder gemeten op een andere pagina? Dan staat je maat er meteen, en
         staat hij ook meteen goed in de maatkiezer. Dat is het verschil tussen
         een rekenhulp en een maatsysteem: je meet één keer. */
      (function herstel(){
        const opgeslagen = herinner();
        if (!opgeslagen || !opgeslagen.cm || veld.value) return;
        veld.value = toon(opgeslagen.cm);
        alles();
      })();
      veld.addEventListener('input', alles);
      veld.addEventListener('change', alles);
      checks.forEach(c => { c.addEventListener('input', tekenBalken); c.addEventListener('change', tekenBalken); });
    }

    /* ---------- hoefschoen ----------
       Twee maten van de hoef zelf, in millimeters. De LENGTE beslist (precies op
       de grens telt als passend, daarboven een maat op), de BREEDTE moet binnen
       de smalle zool van die maat vallen; zo niet, dan zeggen we dat en vragen we
       beide maten op. De maat wordt NIET onthouden in de site (onthoud/markeerOveral):
       D1 van de hoefschoen is een andere maat dan D1 van het halster. */
    const hoef = sectie.querySelector('.rekenhulp__blok[data-voor="hoefschoen"]');
    if (hoef && D.hoefschoen) {
      const vL = hoef.querySelector('[data-meting="hoeflengte"]');
      const vB = hoef.querySelector('[data-meting="hoefbreedte"]');
      const uit = hoef.querySelector('.rekenhulp__uit') || sectie.querySelector('[data-uitkomst]');
      const H = D.hoefschoen, kleinste = H[0], grootste = H[H.length - 1];
      const midden = (a, b) => (Number(a) + Number(b)) / 2;
      /* het hoefmerk in de uitkomst: dezelfde vorm als snippets/hoefmerk.liquid, op de echte maten */
      const hoefHtml = rij => {
        const kx = (0.34 * midden(rij.lengte_van, rij.lengte_tot) / 121.5).toFixed(4), ky = (0.34 * midden(rij.breedte_van, rij.breedte_tot) / 89.5).toFixed(4);
        return `<span class="klem klem--hoef rekenhulp__klem" data-maat="${rij.maat}" data-toestand="gezet" role="img" aria-label="Maat ${rij.maat}">
          <svg viewBox="0 0 64 34" aria-hidden="true"><g class="klem__g" transform="translate(32 17) scale(${kx} ${ky})">
            <path class="klem__zool" vector-effect="non-scaling-stroke" d="M60.75 0 C60.75 -28 36 -44.75 4 -44.75 C-24 -44.75 -46 -37 -57 -24 C-60.5 -16 -61 -8 -60.75 -3 C-56 -5 -52 -4 -49 0 C-52 4 -56 5 -60.75 3 C-61 8 -60.5 16 -57 24 C-46 37 -24 44.75 4 44.75 C36 44.75 60.75 28 60.75 0 Z"/>
            <path class="klem__straal" vector-effect="non-scaling-stroke" d="M-47 -14 L10 0 L-47 14"/>
          </g></svg></span>`;
      };
      const schrijfHoef = (rij, regels) => {
        uit.innerHTML = hoefHtml(rij) + `<strong class="rekenhulp__maat">Maat ${rij.maat}</strong>` +
          regels.map(r => `<span class="rekenhulp__regel">${r}</span>`).join('');
        uit.dataset.maat = rij.maat;
      };
      const reken = () => {
        const l = getal(vL.value), b = getal(vB.value);
        if (l === null || l <= 0) {
          return leeg(uit, b ? 'Vul ook L in, de lengte van de hoef. Die bepaalt de maat.' : '');
        }
        if (l < kleinste.lengte_van) return leeg(uit, `Korter dan onze kleinste maat (${kleinste.maat}, vanaf ${toon(kleinste.lengte_van)} mm). Meet nog een keer de volle lengte, van de teen tot en met de ballen, of stuur ons je meting.`);
        const rij = kiesOpBovengrens(H, 'lengte_tot', l);
        if (!rij) return leeg(uit, `Langer dan onze grootste maat (${grootste.maat}, tot ${toon(grootste.lengte_tot)} mm). Stuur ons je meting, dan kijken we mee.`);
        const regels = [`Lengte ${toon(rij.lengte_van)} tot ${toon(rij.lengte_tot)} mm · breedte ${toon(rij.breedte_van)} tot ${toon(rij.breedte_tot)} mm.`];
        if (b !== null && b > 0) {
          if (b > rij.breedte_tot) {
            const opBreedte = H.find(r => b <= r.breedte_tot);
            regels.push(opBreedte
              ? `Let op: je hoef is breder dan de zool van ${rij.maat} (tot ${toon(rij.breedte_tot)} mm); de breedte wijst naar ${opBreedte.maat}. Bij deze schoen beslist de lengte, maar een te smalle zool knelt. Stuur ons beide maten, dan kijken we mee.`
              : `Let op: je hoef is breder dan onze breedste zool (${toon(grootste.breedte_tot)} mm). Stuur ons beide maten, dan kijken we mee.`);
          } else if (b < rij.breedte_van) {
            regels.push(`Let op: je hoef is smaller dan de zool van ${rij.maat} (vanaf ${toon(rij.breedte_van)} mm); de schoen kan dan in de breedte los zitten. Meet de breedte nog een keer op het breedste punt, of stuur ons beide maten.`);
          } else {
            regels.push(`Lengte en breedte vallen allebei binnen ${rij.maat}.`);
          }
        } else {
          regels.push(`Vul ook B in, de breedte: die moet binnen ${toon(rij.breedte_van)} tot ${toon(rij.breedte_tot)} mm vallen.`);
        }
        regels.push('Per paar. Pas ze eerst binnen, met een plastic zakje om de hoef: dan kunnen ze terug als de maat niet klopt.');
        schrijfHoef(rij, regels);
        if (kiesMaat(rij.maat) && !compact(uit)) meldGekozen(uit, rij.maat);
      };
      [vL, vB].forEach(v => { v.addEventListener('input', reken); v.addEventListener('change', reken); });
    }

    /* ---------- deken ---------- */
    const deken = sectie.querySelector('.rekenhulp__blok[data-voor="deken"]');
    if (deken) {
      const vRug = deken.querySelector('[data-meting="rug"]');
      const vLen = deken.querySelector('[data-meting="lengte"]');
      const uit = deken.querySelector('.rekenhulp__uit') || sectie.querySelector('[data-uitkomst]');
      const reken = () => {
        const rug = getal(vRug.value), len = getal(vLen.value);
        if (len === null || len <= 0) {
          return leeg(uit, rug ? 'Vul ook B in, de totale lengte. Die bepaalt de maat.' : '');
        }
        const rij = kiesOpBovengrens(D.deken, 'lengte', len);
        if (!rij) {
          const grootste = D.deken[D.deken.length - 1];
          return leeg(uit, `Langer dan onze grootste maat (${grootste.lengte} cm). ` +
                           `Stuur ons je meting, dan kijken we mee.`);
        }
        const regels = [
          `Ruglengte ${rij.rug} cm · totale lengte ${rij.lengte} cm`,
          `Breedte ${rij.breedte} cm · halsopening ${rij.hals} cm`,
          /* E, F en G stonden wel in het blad maar nergens op de site. Wie een deken
             koopt wil de borstsluiting en het beenpand kunnen nakijken, want daar zit
             het verschil tussen passen en net niet passen. */
          `Borstsluiting ${rij.borst} cm · borst tot beenpand ${rij.borstbeen} cm · beenpand ${rij.beenpand} cm`,
          rij.dier,
        ];
        /* A mag afwijken, maar dan moet de klant het weten. B beslist. */
        if (rug !== null && rug > 0) {
          const opRug = kiesOpBovengrens(D.deken, 'rug', rug);
          if (opRug && opRug.maat !== rij.maat) {
            regels.push(`Let op: je ruglengte wijst naar ${opRug.maat}. Wij houden ` +
                        `${rij.maat} aan, want de totale lengte bepaalt of de deken ` +
                        `om het dier past. Twijfel je, stuur ons beide maten.`);
          }
        }
        schrijf(uit, rij.maat, regels);

        /* DE VERHOUDING. In de hele reeks is B ongeveer 1,24 keer A: van 1,20
           bij D1 tot 1,26 bij D5. Wijkt jouw dier daar sterk van af, dan is hij
           anders gebouwd dan de reeks aanneemt, en dan zegt geen enkele maat het
           hele verhaal. Dat is geen fout van de klant en ook niet van ons, maar
           het is wel iets wat je wilt weten vóór je bestelt. */
        const balkenVak = deken.querySelector('[data-balken]');
        if (balkenVak) {
          if (rug === null || rug <= 0) { balkenVak.innerHTML = ''; }
          else {
            const verwacht = rug * 1.234;
            const afw = (len - verwacht) / verwacht * 100;
            if (Math.abs(afw) >= 7) {
              const langer = afw > 0;
              balkenVak.innerHTML =
                `<div class="balk balk--buiten"><div class="balk__kop">
                   <span>Verhouding rug en lengte</span><b>${afw > 0 ? '+' : ''}${afw.toFixed(0)}%</b></div>
                 <p class="balk__uitleg">In onze hele reeks is de totale lengte ongeveer
                   1,24 keer de ruglengte. Bij jouw dier is dat
                   ${(len / rug).toFixed(2).replace('.', ',')}, dus hij is
                   ${langer ? 'langer' : 'korter'} gebouwd dan de maten aannemen.
                   ${rij.maat} is de veiligste keuze op lengte, maar stuur ons je
                   metingen: dan kijken we of de halsopening en de breedte ook kloppen.</p></div>`;
            } else {
              balkenVak.innerHTML = '';
            }
          }
        }
      };
      [vRug, vLen].forEach(v => {
        v.addEventListener('input', reken);
        v.addEventListener('change', reken);
      });
    }
  }

  /* ---------- DE TEKENING DOET MEE ----------
     De meettekening op de maatgids stond los van het formulier: een plaatje
     ernaast. Nu is het hetzelfde ding. De bakstuklijn tekent zichzelf zodra hij
     in beeld komt, en springt op de maatkleur zodra je een meting invult.

     De tekening staat in een andere sectie dan de rekenhulp, dus we zoeken hem
     op documentniveau en doen niets als hij er niet is. */
  (function tekeningKoppelen(){
    const fig = document.querySelector('.meetfig');
    if (!fig) return;

    /* zichtbaar worden = de lijn tekenen. Een IntersectionObserver met een
       vangnet: gaat hij niet af, dan staat de lijn er alsnog. */
    const toon = () => fig.classList.add('is-in');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(e => {
        if (e.some(x => x.isIntersecting)) { toon(); io.disconnect(); }
      }, { threshold: 0.25 });
      io.observe(fig);
      setTimeout(toon, 2500);
    } else { toon(); }

    /* meting ingevuld = de lijn krijgt de maatkleur */
    const velden = document.querySelectorAll('[data-meting="bakstuk"]');
    const stem = () => {
      const heeft = [...velden].some(v => getal(v.value) !== null);
      fig.classList.toggle('is-gemeten', heeft);
    };
    velden.forEach(v => { v.addEventListener('input', stem); v.addEventListener('change', stem); });
    stem();
  })();

  /* ═══════════════════════════════════════════════════════════════
     HET MAATSYSTEEM: MEETEN IS KIEZEN.

     Hiervoor gaf de rekenhulp een antwoord en moest je daarna zelf de goede
     maat aanklikken. Dat is geen systeem maar een naslagwerk met een extra
     stap ertussen. Nu doet de meting het werk: hij zet de maat aan in de
     maatkiezer op de productpagina, en hij onthoudt hem voor elke volgende
     pagina.

     ONTHOUDEN GEBEURT IN DE BROWSER, niet op een server. De meting van iemands
     dier is van hem; wij hoeven hem niet te hebben. localStorage kan gooien in
     een privévenster, dus alles staat in try/catch en de site werkt zonder.
     ═══════════════════════════════════════════════════════════════ */
  const SLEUTEL = 'donq-maat';

  function onthoud(maat, cm) {
    try { localStorage.setItem(SLEUTEL, JSON.stringify({ maat, cm })); } catch (e) {}
  }
  function herinner() {
    try { return JSON.parse(localStorage.getItem(SLEUTEL) || 'null'); } catch (e) { return null; }
  }

  /* Zet de maat aan in de maatkiezer. De waarde van de radio is de maatnaam
     zelf ("D4"), dus we zoeken op waarde en niet op volgorde: als er ooit een
     maat bijkomt of wegvalt blijft dit kloppen. */
  function kiesMaat(maat) {
    const kiezer = document.querySelector('.pasvorm__kiezer, .opt__values--maat');
    if (!kiezer) return false;
    const radios = [...document.querySelectorAll('.opt__input')];
    const raak = radios.find(r => (r.value || '').trim().toUpperCase() === maat);
    if (!raak || raak.checked) return !!raak;
    raak.checked = true;
    /* change en input allebei: de variantkiezer van het thema luistert naar
       change, en eigen code luistert vaak naar input. Zonder deze twee weet de
       winkelwagen niet welke variant je hebt gekozen en koop je de verkeerde. */
    raak.dispatchEvent(new Event('input', { bubbles: true }));
    raak.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function meldGekozen(uit, maat) {
    const al = uit.querySelector('.rekenhulp__gekozen');
    if (al) { al.textContent = `${maat} staat voor je klaar bij de maatkeuze.`; return; }
    uit.insertAdjacentHTML('beforeend',
      `<span class="rekenhulp__regel rekenhulp__gekozen">${maat} staat voor je klaar bij de maatkeuze.</span>`);
  }

  /* ---------- JOUW MAAT, OVERAL ----------
     Zodra je een keer gemeten hebt, licht jouw maat op in elke maatrij op de
     site: op de productkaart, in de voettekst, in het megamenu. Dat is wat een
     maatsysteem onderscheidt van een rekenhulp. Je meet een keer en de site
     weet het daarna.

     De klemmen dragen data-maat, dezelfde bron als de maatkiezer. Er wordt niets
     verplaatst of verborgen: alleen de klem van jouw maat gaat van neutraal naar
     gezet, precies zoals hij op de productpagina doet als je hem aanklikt. */
  function markeerOveral(maat) {
    if (!maat) return;
    document.querySelectorAll('.maatrij .klem[data-maat], .maatrij--mini .klem[data-maat]')
      .forEach(k => {
        const eigen = k.dataset.maat === maat;
        k.dataset.toestand = eigen ? 'gezet' : 'neutraal';
        k.classList.toggle('klem--jouwe', eigen);
        if (eigen) k.setAttribute('title', 'Jouw maat');
        else k.removeAttribute('title');
      });
  }

  /* bij binnenkomst meteen, zodat je maat er staat voor je iets doet */
  (function bijBinnenkomst(){
    const o = herinner();
    if (o && o.maat) markeerOveral(o.maat);
  })();

  /* ---------- de maattabel: wisselen tussen halster en deken ---------- */
  document.querySelectorAll('[data-chart]').forEach(chart => {
    const tabs = [...chart.querySelectorAll('.chart__tab')];
    const bladen = [...chart.querySelectorAll('.chart__blad')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => {
        const aan = t === tab;
        t.classList.toggle('is-aan', aan);
        t.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      bladen.forEach(b => b.classList.toggle('is-weg', b.dataset.voor !== tab.dataset.voor));
    }));
  });

  /* PAS NU STARTEN. Eerder stond secties.forEach(start) bovenaan, vóór de
     const SLEUTEL hieronder: herinner() liep dan in de TDZ, de try/catch slikte
     de fout in en het onthouden van de meting was stilletjes dood. */
  secties.forEach(start);

  /* de themabewerker vervangt de sectie-DOM bij elke wijziging */
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('[data-rekenhulp]').forEach(start);
  });
})();
